import { render, staticRenderFns } from "./AddToProject.vue?vue&type=template&id=00de412c"
import script from "./AddToProject.vue?vue&type=script&lang=js"
export * from "./AddToProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports